<template>
	<div id="intro">
		<div id="pcIntro" v-if="!device">
			<div class="scalePart">
				<div class="lanternGroup">
					<div class="lantern"></div>
					<div class="lantern"></div>
					<div class="lantern"></div>
					<div class="lantern"></div>
					<div class="lantern"></div>
					<div class="lantern"></div>
				</div>
				<div class="KV">
					<div class="character lion"></div>
					<div class="couplets">
						<h1><img src="/static/img/title-couplets.png" alt="2018 新年發大財"></h1>
						<div class="btn" @click="goPCLInk()"><span class="center">搶發財金<span class="arrow"></span></span></div>
					</div>
					<div class="character bride"></div>
					<div class="character fatBoy"></div>
					<div class="character oldWoman"></div>
					<div class="character officeLady"></div>
					<div class="character dog"></div>
					<div class="character tsaiShen">
						<div class="treasureGroup">
							<div class="treasure coin coin_1"></div>
							<div class="treasure coin coin_2"></div>
							<div class="treasure coin coin_3"></div>
							<div class="treasure coin coin_4"></div>
							<div class="treasure coin coin_5"></div>
							<div class="treasure coin coin_6"></div>
							<div class="treasure coin coin_7"></div>
							<div class="treasure coin coin_8"></div>
							<div class="treasure coin coin_9"></div>
							<div class="treasure redPacket redPacket_1"></div>
							<div class="treasure redPacket redPacket_2"></div>
							<div class="treasure redPacket redPacket_3"></div>
							<div class="treasure redPacket redPacket_4"></div>
							<div class="treasure ingots ingots_1"></div>
							<div class="treasure ingots ingots_2"></div>
							<div class="treasure ingots ingots_3"></div>
							<div class="treasure ingots ingots_4"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="linkSection">
				<a target="_blank" href="http://www.sobo.com.tw/design/" @click="openSobo" class="logoSobo"><img src="/static/img/link-sobo.png" alt="SOBO 淞泊創意設計"></a>
				<a target="_blank" href="http://www.weddings.tw/" @click="openWedding" class="logoWeddings"><img src="/static/img/link-weddings.png" alt="Weddings 新娘物語"></a>
			</div>
		</div>



		<div id="moIntro" v-if="device">
			<div class="KV">
				<div class="character lion"></div>
				<div class="couplets">
					<h1><img src="/static/img/mobile/title-couplets.png" width="137" height="104" alt="2018 新年發大財"></h1>
				</div>
				<div class="character bride"></div>
				<div class="character fatBoy"></div>
				<div class="character oldWoman"></div>
				<div class="character officeLady"></div>
				<div class="character dog"></div>
				<div class="character tsaiShen">
					<div class="treasureGroup">
						<div class="treasure coin coin_1"></div>
						<div class="treasure coin coin_2"></div>
						<div class="treasure coin coin_3"></div>
						<div class="treasure coin coin_4"></div>
						<div class="treasure coin coin_5"></div>
						<div class="treasure coin coin_6"></div>
						<div class="treasure coin coin_7"></div>
						<div class="treasure coin coin_8"></div>
						<div class="treasure coin coin_9"></div>
						<div class="treasure redPacket redPacket_1"></div>
						<div class="treasure redPacket redPacket_2"></div>
						<div class="treasure redPacket redPacket_3"></div>
						<div class="treasure redPacket redPacket_4"></div>
						<div class="treasure ingots ingots_1"></div>
						<div class="treasure ingots ingots_2"></div>
						<div class="treasure ingots ingots_3"></div>
						<div class="treasure ingots ingots_4"></div>
					</div>
				</div>
				<button class="btn" @click="goMOLInk()"><span class="center">搶發財金<span class="arrow"></span></span></button>
			</div>
			<div class="linkSection">
				<a href="http://www.sobo.com.tw/design/" @click="openSobo" class="logoSobo"><img src="/static/img/link-sobo.png" alt="SOBO 淞泊創意設計"></a>
				<a href="http://www.weddings.tw/" @click="openWedding" class="logoWeddings"><img src="/static/img/link-weddings.png" alt="Weddings 新娘物語"></a>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'Intro',
		data () {
			return {
				text: ''
			}
		},
		methods: {
			...mapActions([
				'enterRoom',
				'setDevice'
			]),
			createRoomNumber: function () {
				let randomText = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
				this.text = '';
				for (let i = 0; i < 5; i++) {
					this.text += randomText[Math.floor(Math.random() * randomText.length)];
				}
			},
			goPCLInk: function () {
				this.createRoomNumber();
				socket.emit('checkRoomExist', this.text);
			},
			goMOLInk: function () {
				this.$router.replace('MobileGame');
			},
			playMusic: function (target) {
				let audio = document.getElementById(target);
				audio.currentTime = 0;
				audio.play();
			},
			pauseMusic: function (target) {
				let audio = document.getElementById(target);
				audio.pause();
				audio.currentTime = 0;
			},
			openSobo: function () {
				gtag('event', 'click', {'event_category': 'Sobo New Year', 'event_label': '點擊Logo'});
				window.open("http://www.sobo.com.tw/design/");
			},
			openWedding: function () {
				window.open("http://www.weddings.tw/");
			}
		},
		computed: {
			...mapGetters({
				device: 'isMobile'
			})
		},
		mounted () {
			let audio = document.getElementById('introMusic');
			let self = this;
			setTimeout(function () {
			$(".KV .btn").one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
				$(".tsaiShen").addClass("right");
				$(".treasureGroup").addClass("active");
			});
			}, 500);
			this.setDevice(window.mobileAndTabletcheck());

			if ($(window).height() <= 987 && !window.mobileAndTabletcheck()) {
				$(".scalePart").css({
					transform: 'scale(' + $(window).height() / 987 + ')',
					MozTransform: 'scale(' + $(window).height() / 987 + ')',
					WebkitTransform: 'scale(' + $(window).height() / 987 + ')',
					msTransform: 'scale(' + $(window).height() / 987 + ')'
				});
			} else {
				$(".scalePart").attr("css", "");
			}

			socket.removeAllListeners();
			socket.on('checkRoom', function (roomCode) {
				if (roomCode) {
					self.goPCLInk();
				} else {
					self.enterRoom(self.text);
					self.$router.replace('Game/' + self.text);
				}
			});

			if (!this.device) {
				let playPromise = audio.play();
				if (playPromise !== undefined) {
					playPromise.then(_ => {
						self.pauseMusic('gamingMusic');
						self.pauseMusic('endingMusic');
						audio.play();
					})
					.catch(error => {});
				}
			}

			if (this.device) {
				if ($("#moIntro").is(":visible") || !$("#moIntro").hasClass("active")) {
					$("#moIntro").addClass("active");
				}
			} else {
				if ($("#pcIntro").is(":visible") || !$("#pcIntro").hasClass("active")) {
					$("#pcIntro").addClass("active");
				}
			}
		}
	}
</script>



<style lang="sass" scoped>
	%clearfix
		zoom: 1
		&::before
			content: ""
			display: table
		&::after
			content: ""
			display: table
			clear: both

	#intro
		width: 100%
		height: 100%
	#pcIntro
		position: relative
		min-width: 1200px
		height: 100%
		background-repeat: no-repeat
		overflow: hidden
		-webkit-background-size: auto 250%
		-o-background-size: auto 250%
		background-size: auto 250%
		background-position: center center
		background-image: url(/static/img/bg-intro.jpg)
		-webkit-transform-origin: center top
		-moz-transform-origin: center top
		-ms-transform-origin: center top
		-o-transform-origin: center top
		transform-origin: center top
		.KV
			position: absolute
			top: 50%
			left: 50%
			-webkit-transform: translate(-50%, -50%)
			-moz-transform: translate(-50%, -50%)
			-ms-transform: translate(-50%, -50%)
			-o-transform: translate(-50%, -50%)
			transform: translate(-50%, -50%)
		.couplets
			@extend %clearfix
			position: relative
			text-align: center
			width: 736px
			height: 744px
			background-image: url(/static/img/bg-couplets.png)
			opacity: 0
			-webkit-transform: scale(0.2)
			-moz-transform: scale(0.2)
			-ms-transform: scale(0.2)
			-o-transform: scale(0.2)
			transform: scale(0.2)
			h1
				opacity: 0
				-webkit-transform: scale(0.2)
				-moz-transform: scale(0.2)
				-ms-transform: scale(0.2)
				-o-transform: scale(0.2)
				transform: scale(0.2)
				margin: 230px 0 10px
				text-align: center
		.scalePart
			position: relative
			-webkit-transform-origin: center top
			-moz-transform-origin: center top
			-ms-transform-origin: center top
			-o-transform-origin: center top
			transform-origin: center top
			min-width: 1200px
			height: 987px
		.lanternGroup
			position: fixed
			width: 1px
			height: 1px
			top: -694px
			left: 0
			right: 0
			bottom: 0
			margin: auto
			background-color: #F00
			.lantern
				position: absolute
				width: 78px
				height: 120px
				background-image: url(/static/img/item-lantern.png)
				-webkit-transform-origin: center top
				-moz-transform-origin: center top
				-ms-transform-origin: center top
				-o-transform-origin: center top
				transform-origin: center top
				-webkit-transition: transform 0.5s
				-moz-transition: transform 0.5s
				-ms-transition: transform 0.5s
				-o-transition: transform 0.5s
				transition: transform 0.5s
				&:hover
					-webkit-animation: shake 0.5s
					-moz-animation: shake 0.5s
					-o-animation: shake 0.5s
					animation: shake 0.5s
				&:nth-child(1)
					left: 265px
				&:nth-child(2)
					top: 5px
					left: -340px
				&:nth-child(3)
					top: -10px
					left: 475px
				&:nth-child(4)
					top: -3px
					left: -548px
				&:nth-child(5)
					top: -24px
					left: 700px
				&:nth-child(6)
					top: -13px
					left: -750px
		.linkSection
			position: fixed
			z-index: 5
			right: 0
			bottom: 0
			padding: 14px 20px 0 25px
			background: rgba(0, 0, 0, 0.6)
			a
				display: inline-block
				margin: 0 0 0 4px
		.character
			background-repeat: no-repeat
			background-image: url(/static/img/character-intro.png)
			-webkit-transform-origin: center bottom
			-moz-transform-origin: center bottom
			-ms-transform-origin: center bottom
			-o-transform-origin: center bottom
			transform-origin: center bottom
		.lion
			position: absolute
			right: -300px
			top: 24px
			width: 500px
			height: 666px
			background-position: 0 0
			opacity: 0
			-webkit-transform: translateX(100px)
			-moz-transform: translateX(100px)
			-ms-transform: translateX(100px)
			-o-transform: translateX(100px)
			transform: translateX(100px)
		.bride
			position: absolute
			top: 240px
			left: -320px
			width: 360px
			height: 530px
			background-position: -820px 0
			opacity: 0
			-webkit-transform: translateY(150px)
			-moz-transform: translateY(150px)
			-ms-transform: translateY(150px)
			-o-transform: translateY(150px)
			transform: translateY(150px)
		.fatBoy
			position: absolute
			top: 298px
			right: -320px
			width: 330px
			height: 460px
			background-position: 0 -666px
			opacity: 0
			-webkit-transform: translateY(150px)
			-moz-transform: translateY(150px)
			-ms-transform: translateY(150px)
			-o-transform: translateY(150px)
			transform: translateY(150px)
		.oldWoman
			position: absolute
			left: 520px
			top: 430px
			width: 320px
			height: 380px
			background-position: -500px -274px
			opacity: 0
			-webkit-transform: translateY(150px)
			-moz-transform: translateY(150px)
			-ms-transform: translateY(150px)
			-o-transform: translateY(150px)
			transform: translateY(150px)
		.officeLady
			position: absolute
			top: 362px
			left: -104px
			width: 230px
			height: 430px
			background-position: -330px -666px
			opacity: 0
			-webkit-transform: translateY(150px)
			-moz-transform: translateY(150px)
			-ms-transform: translateY(150px)
			-o-transform: translateY(150px)
			transform: translateY(150px)
		.dog
			position: absolute
			top: 496px
			left: 94px
			width: 170px
			height: 290px
			background-position: -560px -666px
			opacity: 0
			-webkit-transform: translateY(150px)
			-moz-transform: translateY(150px)
			-ms-transform: translateY(150px)
			-o-transform: translateY(150px)
			transform: translateY(150px)
		.tsaiShen
			position: absolute
			margin: auto
			top: 0
			left: 0
			right: 0
			bottom: 0
			width: 274px
			height: 274px
			background-position: -500px 0
			&.right
				background-position: -730px -666px
		.btn
			position: relative
			opacity: 0
			font-weight: bold
			color: #FFF
			-webkit-border-radius: 50px
			border-radius: 50px
			display: inline-block
			text-align: center
			padding: 3px
			text-decoration: none
			cursor: pointer
			-webkit-box-shadow: #108B86 0 10px 0
			box-shadow: #108B86 0 10px 0
			background: #21A8A3
			background: -moz-linear-gradient(top, #21A8A3 0%, #25B1AC 100%)
			background: -webkit-linear-gradient(top, #21A8A3 0%, #25B1AC 100%)
			background: linear-gradient(to bottom, #21A8A3 0%, #25B1AC 100%)
			opacity: 0
			-webkit-transform: scale(0.7)
			-moz-transform: scale(0.7)
			-ms-transform: scale(0.7)
			-o-transform: scale(0.7)
			transform: scale(0.7)
			&:active
				margin-top: 10px
				-webkit-box-shadow: none
				box-shadow: none
			.center
				position: relative
				padding: 8px 25px 10px
				-webkit-box-sizing: border-box
				-moz-box-sizing: border-box
				box-sizing: border-box
				font-weight: bold
				color: #FFF
				font-size: 34px
				text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 5px
				background-color: #21A8A3
				display: block
				width: 100%
				height: 100%
				-webkit-border-radius: 50px
				border-radius: 50px
			.arrow
				position: relative
				display: inline-block
				width: 32px
				height: 32px
				background-color: #FFF
				vertical-align: middle
				margin-top: -7px
				margin-left: 10px
				-webkit-border-radius: 50%
				border-radius: 50%
				-webkit-box-shadow: rgba(0, 0, 0, 0.5) 1px 1px 5px
				box-shadow: rgba(0, 0, 0, 0.5) 1px 1px 5px
				&::before
					position: absolute
					display: block
					content: ""
					width: 0
					height: 0
					top: 0
					left: 2px
					bottom: 0
					right: 0
					margin: auto
					border-style: solid
					border-color: transparent transparent transparent #21A8A3
					border-width: 8px 0 8px 10px
		.treasureGroup
			.treasure
				position: absolute
				&.coin
					opacity: 0
					width: 28px
					height: 28px
					background-image: url(/static/img/treasure_coinUnit.png)
				&.redPacket
					opacity: 0
					width: 54px
					height: 78px
					background-image: url(/static/img/treasure_redPacket.png)
				&.ingots
					opacity: 0
					width: 84px
					height: 54px
					background-image: url(/static/img/treasure_ingots.png)

	// animation
	#pcIntro
		&.active
			.couplets
				-webkit-animation: couplets 0.5s forwards
				-moz-animation: couplets 0.5s forwards
				-o-animation: couplets 0.5s forwards
				animation: couplets 0.5s forwards
				-webkit-animation-delay: 0.7s
				-moz-animation-delay: 0.7s
				-o-animation-delay: 0.7s
				animation-delay: 0.7s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
				h1
					-webkit-animation: slogan 2.5s forwards
					-moz-animation: slogan 2.5s forwards
					-o-animation: slogan 2.5s forwards
					animation: slogan 2.5s forwards
					-webkit-animation-delay: 1.1s
					-moz-animation-delay: 1.1s
					-o-animation-delay: 1.1s
					animation-delay: 1.1s
					-webkit-animation-timing-function: linear
					-moz-animation-timing-function: linear
					-o-animation-timing-function: linear
					animation-timing-function: linear
			.lion
				-webkit-animation: lion 0.1s forwards
				-moz-animation: lion 0.1s forwards
				-o-animation: lion 0.1s forwards
				animation: lion 0.1s forwards
				-webkit-animation-delay: 1.1s
				-moz-animation-delay: 1.1s
				-o-animation-delay: 1.1s
				animation-delay: 1.1s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.bride
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 1.9s
				-moz-animation-delay: 1.9s
				-o-animation-delay: 1.9s
				animation-delay: 1.9s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.fatBoy
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2s
				-moz-animation-delay: 2s
				-o-animation-delay: 2s
				animation-delay: 2s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.oldWoman
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2.6s
				-moz-animation-delay: 2.6s
				-o-animation-delay: 2.6s
				animation-delay: 2.6s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.officeLady
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2.4s
				-moz-animation-delay: 2.4s
				-o-animation-delay: 2.4s
				animation-delay: 2.4s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.dog
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2.2s
				-moz-animation-delay: 2.2s
				-o-animation-delay: 2.2s
				animation-delay: 2.2s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.tsaiShen
				-webkit-animation: tsaiShen 0.5s forwards
				-moz-animation: tsaiShen 0.5s forwards
				-o-animation: tsaiShen 0.5s forwards
				animation: tsaiShen 0.5s forwards
				-webkit-animation-delay: 0.3s
				-moz-animation-delay: 0.3s
				-o-animation-delay: 0.3s
				animation-delay: 0.3s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.btn
				-webkit-animation: btn 0.5s forwards
				-moz-animation: btn 0.5s forwards
				-o-animation: btn 0.5s forwards
				animation: btn 0.5s forwards
				-webkit-animation-delay: 3.1s
				-moz-animation-delay: 3.1s
				-o-animation-delay: 3.1s
				animation-delay: 3.1s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear

		.treasureGroup
			&.active
				.treasure
					&.coin
						&_1
							top: 15px
							right: 10px
							-webkit-animation: coin1 1s forwards
							-moz-animation: coin1 1s forwards
							-o-animation: coin1 1s forwards
							animation: coin1 1s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
						&_2
							top: -80px
							right: -40px
							-webkit-animation: coin2 0.7s forwards
							-moz-animation: coin2 0.7s forwards
							-o-animation: coin2 0.7s forwards
							animation: coin2 0.7s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_3
							top: 10px
							right: 140px
							-webkit-animation: coin3 0.7s forwards
							-moz-animation: coin3 0.7s forwards
							-o-animation: coin3 0.7s forwards
							animation: coin3 0.7s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_4
							top: -80px
							right: -40px
							-webkit-animation: coin4 0.8s forwards
							-moz-animation: coin4 0.8s forwards
							-o-animation: coin4 0.8s forwards
							animation: coin4 0.8s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.15
							-moz-animation-delay: 0.15
							-o-animation-delay: 0.15
							animation-delay: 0.15
						&_5
							top: -80px
							right: -40px
							-webkit-animation: coin5 0.9s forwards
							-moz-animation: coin5 0.9s forwards
							-o-animation: coin5 0.9s forwards
							animation: coin5 0.9s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_6
							top: -80px
							right: -40px
							-webkit-animation: coin6 1s forwards
							-moz-animation: coin6 1s forwards
							-o-animation: coin6 1s forwards
							animation: coin6 1s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_7
							top: -80px
							right: -40px
							-webkit-animation: coin7 0.9s forwards
							-moz-animation: coin7 0.9s forwards
							-o-animation: coin7 0.9s forwards
							animation: coin7 0.9s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.15
							-moz-animation-delay: 0.15
							-o-animation-delay: 0.15
							animation-delay: 0.15
						&_8
							top: -80px
							right: -140px
							-webkit-animation: coin8 0.9s forwards
							-moz-animation: coin8 0.9s forwards
							-o-animation: coin8 0.9s forwards
							animation: coin8 0.9s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_9
							top: -65px
							right: -170px
							-webkit-animation: coin9 1s forwards
							-moz-animation: coin9 1s forwards
							-o-animation: coin9 1s forwards
							animation: coin9 1s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
					&.redPacket
						&_1
							top: -20px
							right: 80px
							-webkit-animation: redPacket1 0.7s
							-moz-animation: redPacket1 0.7s
							-o-animation: redPacket1 0.7s
							animation: redPacket1 0.7s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_2
							top: -160px
							right: -130px
							-webkit-animation: redPacket2 0.7s
							-moz-animation: redPacket2 0.7s
							-o-animation: redPacket2 0.7s
							animation: redPacket2 0.7s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_3
							top: -160px
							right: -30px
							-webkit-animation: redPacket3 0.7s
							-moz-animation: redPacket3 0.7s
							-o-animation: redPacket3 0.7s
							animation: redPacket3 0.7s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_4
							top: -160px
							right: -30px
							-webkit-animation: redPacket3 0.9s
							-moz-animation: redPacket3 0.9s
							-o-animation: redPacket3 0.9s
							animation: redPacket3 0.9s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
					&.ingots
						@for $i from 1 through 4
							&_#{$i}
								top: -150px
								right: -80px
								-webkit-animation: ingots#{$i} 0.7s
								-moz-animation: ingots#{$i} 0.7s
								-o-animation: ingots#{$i} 0.7s
								animation: ingots#{$i} 0.7s
								-webkit-animation-timing-function: linear
								-moz-animation-timing-function: linear
								-o-animation-timing-function: linear
								animation-timing-function: linear
						&_1
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_2
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_3
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1

	@keyframes shake
		0%
			-webkit-transform: rotate(10deg)
			-moz-transform: rotate(10deg)
			-ms-transform: rotate(10deg)
			-o-transform: rotate(10deg)
			transform: rotate(10deg)
		50%
			-webkit-transform: rotate(-10deg)
			-moz-transform: rotate(-10deg)
			-ms-transform: rotate(-10deg)
			-o-transform: rotate(-10deg)
			transform: rotate(-10deg)
		100%
			-webkit-transform: rotate(0deg)
			-moz-transform: rotate(0deg)
			-ms-transform: rotate(0deg)
			-o-transform: rotate(0deg)
			transform: rotate(0deg)
	@keyframes comeOut
		0%
			-webkit-transform: scale(0.4)
			-moz-transform: scale(0.4)
			-ms-transform: scale(0.4)
			-o-transform: scale(0.4)
			transform: scale(0.4)
		50%
			-webkit-transform: scale(1) translateY(-30px)
			-moz-transform: scale(1) translateY(-30px)
			-ms-transform: scale(1) translateY(-30px)
			-o-transform: scale(1) translateY(-30px)
			transform: scale(1) translateY(-30px)
		75%
			-webkit-transform: scaleY(0.9) translateY(10px)
			-moz-transform: scaleY(0.9) translateY(10px)
			-ms-transform: scaleY(0.9) translateY(10px)
			-o-transform: scaleY(0.9) translateY(10px)
			transform: scaleY(0.9) translateY(10px)
		100%
			opacity: 1
			-webkit-transform: scale(1) translateY(0)
			-moz-transform: scale(1) translateY(0)
			-ms-transform: scale(1) translateY(0)
			-o-transform: scale(1) translateY(0)
			transform: scale(1) translateY(0)
	@keyframes tsaiShen
		100%
			-webkit-transform: translate(-311px, -242px)
			-moz-transform: translate(-311px, -242px)
			-ms-transform: translate(-311px, -242px)
			-o-transform: translate(-311px, -242px)
			transform: translate(-311px, -242px)
	@keyframes lion
		100%
			opacity: 1
			-webkit-transform: translateX(0)
			-moz-transform: translateX(0)
			-ms-transform: translateX(0)
			-o-transform: translateX(0)
			transform: translateX(0)
	@keyframes couplets
		60%
			opacity: 1
			-webkit-transform: scale(1.1)
			-moz-transform: scale(1.1)
			-ms-transform: scale(1.1)
			-o-transform: scale(1.1)
			transform: scale(1.1)
		100%
			opacity: 1
			-webkit-transform: scale(1)
			-moz-transform: scale(1)
			-ms-transform: scale(1)
			-o-transform: scale(1)
			transform: scale(1)
	@keyframes slogan
		8%
			opacity: 1
			-webkit-transform: scale(1.2)
			-moz-transform: scale(1.2)
			-ms-transform: scale(1.2)
			-o-transform: scale(1.2)
			transform: scale(1.2)
		12%
			opacity: 1
			-webkit-transform: scale(1.1)
			-moz-transform: scale(1.1)
			-ms-transform: scale(1.1)
			-o-transform: scale(1.1)
			transform: scale(1.1)
		84%
			opacity: 1
			-webkit-transform: scale(1.1)
			-moz-transform: scale(1.1)
			-ms-transform: scale(1.1)
			-o-transform: scale(1.1)
			transform: scale(1.1)
		92%
			opacity: 1
			-webkit-transform: scale(1) translateY(-45px)
			-moz-transform: scale(1) translateY(-45px)
			-ms-transform: scale(1) translateY(-45px)
			-o-transform: scale(1) translateY(-45px)
			transform: scale(1) translateY(-45px)
		100%
			opacity: 1
			-webkit-transform: scale(1) translateY(-30px)
			-moz-transform: scale(1) translateY(-30px)
			-ms-transform: scale(1) translateY(-30px)
			-o-transform: scale(1) translateY(-30px)
			transform: scale(1) translateY(-30px)
	@keyframes btn
		60%
			opacity: 1
			-webkit-transform: scale(1) translateY(-70px)
			-moz-transform: scale(1) translateY(-70px)
			-ms-transform: scale(1) translateY(-70px)
			-o-transform: scale(1) translateY(-70px)
			transform: scale(1) translateY(-70px)
		100%
			opacity: 1
			-webkit-transform: scale(1) translateY(-50px)
			-moz-transform: scale(1) translateY(-50px)
			-ms-transform: scale(1) translateY(-50px)
			-o-transform: scale(1) translateY(-50px)
			transform: scale(1) translateY(-50px)

	@keyframes coin1
		20%
			opacity: 1
			-webkit-transform: translate(120px, -40px)
			-moz-transform: translate(120px, -40px)
			-ms-transform: translate(120px, -40px)
			-o-transform: translate(120px, -40px)
			transform: translate(120px, -40px)
		50%
			opacity: 1
			-webkit-transform: translate(280px, 22px)
			-moz-transform: translate(280px, 22px)
			-ms-transform: translate(280px, 22px)
			-o-transform: translate(280px, 22px)
			transform: translate(280px, 22px)
		80%
			opacity: 1
			-webkit-transform: translate(534px, 298px)
			-moz-transform: translate(534px, 298px)
			-ms-transform: translate(534px, 298px)
			-o-transform: translate(534px, 298px)
			transform: translate(534px, 298px)
		100%
			opacity: 0
			-webkit-transform: translate(694px, 540px)
			-moz-transform: translate(694px, 540px)
			-ms-transform: translate(694px, 540px)
			-o-transform: translate(694px, 540px)
			transform: translate(694px, 540px)
	@keyframes coin2
		28%
			opacity: 1
			-webkit-transform: translate(310px, 162px)
			-moz-transform: translate(310px, 162px)
			-ms-transform: translate(310px, 162px)
			-o-transform: translate(310px, 162px)
			transform: translate(310px, 162px)
		72%
			opacity: 0.77
			-webkit-transform: translate(526px, 530px)
			-moz-transform: translate(526px, 530px)
			-ms-transform: translate(526px, 530px)
			-o-transform: translate(526px, 530px)
			transform: translate(526px, 530px)
		100%
			opacity: 0
			-webkit-transform: translate(636px, 716px)
			-moz-transform: translate(636px, 716px)
			-ms-transform: translate(636px, 716px)
			-o-transform: translate(636px, 716px)
			transform: translate(636px, 716px)
	@keyframes coin3
		28%
			opacity: 1
			-webkit-transform: translate(-124px, 174px)
			-moz-transform: translate(-124px, 174px)
			-ms-transform: translate(-124px, 174px)
			-o-transform: translate(-124px, 174px)
			transform: translate(-124px, 174px)
		86%
			opacity: 0.77
			-webkit-transform: translate(-254px, 484px)
			-moz-transform: translate(-254px, 484px)
			-ms-transform: translate(-254px, 484px)
			-o-transform: translate(-254px, 484px)
			transform: translate(-254px, 484px)
		100%
			opacity: 0
			-webkit-transform: translate(-362px, 652px)
			-moz-transform: translate(-362px, 652px)
			-ms-transform: translate(-362px, 652px)
			-o-transform: translate(-362px, 652px)
			transform: translate(-362px, 652px)
	@keyframes coin4
		28%
			opacity: 1
			-webkit-transform: translate(24px, 194px)
			-moz-transform: translate(24px, 194px)
			-ms-transform: translate(24px, 194px)
			-o-transform: translate(24px, 194px)
			transform: translate(24px, 194px)
		86%
			opacity: 0.77
			-webkit-transform: translate(60px, 486px)
			-moz-transform: translate(60px, 486px)
			-ms-transform: translate(60px, 486px)
			-o-transform: translate(60px, 486px)
			transform: translate(60px, 486px)
		100%
			opacity: 0
			-webkit-transform: translate(80px, 632px)
			-moz-transform: translate(80px, 632px)
			-ms-transform: translate(80px, 632px)
			-o-transform: translate(80px, 632px)
			transform: translate(80px, 632px)
	@keyframes coin5
		33%
			opacity: 1
			-webkit-transform: translate(-166px, 158px)
			-moz-transform: translate(-166px, 158px)
			-ms-transform: translate(-166px, 158px)
			-o-transform: translate(-166px, 158px)
			transform: translate(-166px, 158px)
		78%
			opacity: 0.77
			-webkit-transform: translate(-242px, 444px)
			-moz-transform: translate(-242px, 444px)
			-ms-transform: translate(-242px, 444px)
			-o-transform: translate(-242px, 444px)
			transform: translate(-242px, 444px)
		100%
			opacity: 0
			-webkit-transform: translate(-336px, 632px)
			-moz-transform: translate(-336px, 632px)
			-ms-transform: translate(-336px, 632px)
			-o-transform: translate(-336px, 632px)
			transform: translate(-336px, 632px)
	@keyframes coin6
		30%
			opacity: 1
			-webkit-transform: translate(236px, 10px)
			-moz-transform: translate(236px, 10px)
			-ms-transform: translate(236px, 10px)
			-o-transform: translate(236px, 10px)
			transform: translate(236px, 10px)
		80%
			opacity: 0.77
			-webkit-transform: translate(596px, 258px)
			-moz-transform: translate(596px, 258px)
			-ms-transform: translate(596px, 258px)
			-o-transform: translate(596px, 258px)
			transform: translate(596px, 258px)
		100%
			opacity: 0
			-webkit-transform: translate(762px, 686px)
			-moz-transform: translate(762px, 686px)
			-ms-transform: translate(762px, 686px)
			-o-transform: translate(762px, 686px)
			transform: translate(762px, 686px)
	@keyframes coin7
		30%
			opacity: 1
			-webkit-transform: translate(-28px, 212px)
			-moz-transform: translate(-28px, 212px)
			-ms-transform: translate(-28px, 212px)
			-o-transform: translate(-28px, 212px)
			transform: translate(-28px, 212px)
		90%
			opacity: 0.77
			-webkit-transform: translate(-72px, 528px)
			-moz-transform: translate(-72px, 528px)
			-ms-transform: translate(-72px, 528px)
			-o-transform: translate(-72px, 528px)
			transform: translate(-72px, 528px)
		100%
			opacity: 0
			-webkit-transform: translate(-94px, 688px)
			-moz-transform: translate(-94px, 688px)
			-ms-transform: translate(-94px, 688px)
			-o-transform: translate(-94px, 688px)
			transform: translate(-94px, 688px)
	@keyframes coin8
		33%
			opacity: 1
			-webkit-transform: translate(260px, 68px)
			-moz-transform: translate(260px, 68px)
			-ms-transform: translate(260px, 68px)
			-o-transform: translate(260px, 68px)
			transform: translate(260px, 68px)
		88%
			opacity: 0.77
			-webkit-transform: translate(592px, 378px)
			-moz-transform: translate(592px, 378px)
			-ms-transform: translate(592px, 378px)
			-o-transform: translate(592px, 378px)
			transform: translate(592px, 378px)
		100%
			opacity: 0
			-webkit-transform: translate(748px, 674px)
			-moz-transform: translate(748px, 674px)
			-ms-transform: translate(748px, 674px)
			-o-transform: translate(748px, 674px)
			transform: translate(748px, 674px)
	@keyframes coin9
		30%
			opacity: 1
			-webkit-transform: translate(288px, 102px)
			-moz-transform: translate(288px, 102px)
			-ms-transform: translate(288px, 102px)
			-o-transform: translate(288px, 102px)
			transform: translate(288px, 102px)
		80%
			opacity: 0.77
			-webkit-transform: translate(602px, 380px)
			-moz-transform: translate(602px, 380px)
			-ms-transform: translate(602px, 380px)
			-o-transform: translate(602px, 380px)
			transform: translate(602px, 380px)
		100%
			opacity: 0
			-webkit-transform: translate(718px, 582px)
			-moz-transform: translate(718px, 582px)
			-ms-transform: translate(718px, 582px)
			-o-transform: translate(718px, 582px)
			transform: translate(718px, 582px)

	@keyframes redPacket1
		85%
			opacity: 1
			-webkit-transform: translate(-122px, 428px)
			-moz-transform: translate(-122px, 428px)
			-ms-transform: translate(-122px, 428px)
			-o-transform: translate(-122px, 428px)
			transform: translate(-122px, 428px)
		100%
			opacity: 0
			-webkit-transform: translate(-206px, 626px)
			-moz-transform: translate(-206px, 626px)
			-ms-transform: translate(-206px, 626px)
			-o-transform: translate(-206px, 626px)
			transform: translate(-206px, 626px)
	@keyframes redPacket2
		72%
			opacity: 1
			-webkit-transform: translate(230px, 510px)
			-moz-transform: translate(230px, 510px)
			-ms-transform: translate(230px, 510px)
			-o-transform: translate(230px, 510px)
			transform: translate(230px, 510px)
		100%
			opacity: 0
			-webkit-transform: translate(350px, 696px)
			-moz-transform: translate(350px, 696px)
			-ms-transform: translate(350px, 696px)
			-o-transform: translate(350px, 696px)
			transform: translate(350px, 696px)
	@keyframes redPacket3
		60%
			opacity: 1
			-webkit-transform: translate(38px, 546px)
			-moz-transform: translate(38px, 546px)
			-ms-transform: translate(38px, 546px)
			-o-transform: translate(38px, 546px)
			transform: translate(38px, 546px)
		100%
			opacity: 0
			-webkit-transform: translate(50px, 746px)
			-moz-transform: translate(50px, 746px)
			-ms-transform: translate(50px, 746px)
			-o-transform: translate(50px, 746px)
			transform: translate(50px, 746px)
	@keyframes redPacket4
		33%
			opacity: 1
			-webkit-transform: translate(448px, 168px)
			-moz-transform: translate(448px, 168px)
			-ms-transform: translate(448px, 168px)
			-o-transform: translate(448px, 168px)
			transform: translate(448px, 168px)
		78%
			opacity: 1
			-webkit-transform: translate(602px, 424px)
			-moz-transform: translate(602px, 424px)
			-ms-transform: translate(602px, 424px)
			-o-transform: translate(602px, 424px)
			transform: translate(602px, 424px)
		100%
			opacity: 0
			-webkit-transform: translate(764px, 640px)
			-moz-transform: translate(764px, 640px)
			-ms-transform: translate(764px, 640px)
			-o-transform: translate(764px, 640px)
			transform: translate(764px, 640px)

	@keyframes ingots1
		85%
			opacity: 1
			-webkit-transform: translate(-274px, 456px)
			-moz-transform: translate(-274px, 456px)
			-ms-transform: translate(-274px, 456px)
			-o-transform: translate(-274px, 456px)
			transform: translate(-274px, 456px)
		100%
			opacity: 0
			-webkit-transform: translate(-384px, 638px)
			-moz-transform: translate(-384px, 638px)
			-ms-transform: translate(-384px, 638px)
			-o-transform: translate(-384px, 638px)
			transform: translate(-384px, 638px)
	@keyframes ingots2
		85%
			opacity: 1
			-webkit-transform: translate(118px, 436px)
			-moz-transform: translate(118px, 436px)
			-ms-transform: translate(118px, 436px)
			-o-transform: translate(118px, 436px)
			transform: translate(118px, 436px)
		100%
			opacity: 0
			-webkit-transform: translate(166px, 610px)
			-moz-transform: translate(166px, 610px)
			-ms-transform: translate(166px, 610px)
			-o-transform: translate(166px, 610px)
			transform: translate(166px, 610px)
	@keyframes ingots3
		85%
			opacity: 1
			-webkit-transform: translate(498px, 476px)
			-moz-transform: translate(498px, 476px)
			-ms-transform: translate(498px, 476px)
			-o-transform: translate(498px, 476px)
			transform: translate(498px, 476px)
		100%
			opacity: 0
			-webkit-transform: translate(698px, 666px)
			-moz-transform: translate(698px, 666px)
			-ms-transform: translate(698px, 666px)
			-o-transform: translate(698px, 666px)
			transform: translate(698px, 666px)
	@keyframes ingots4
		85%
			opacity: 1
			-webkit-transform: translate(266px, 560px)
			-moz-transform: translate(266px, 560px)
			-ms-transform: translate(266px, 560px)
			-o-transform: translate(266px, 560px)
			transform: translate(266px, 560px)
		100%
			opacity: 0
			-webkit-transform: translate(372px, 782px)
			-moz-transform: translate(372px, 782px)
			-ms-transform: translate(372px, 782px)
			-o-transform: translate(372px, 782px)
			transform: translate(372px, 782px)




	#moIntro
		position: fixed
		top: 0
		left: 0
		width: 100%
		height: 100%
		text-align: center
		-webkit-background-size: auto 1400px
		-o-background-size: auto 1400px
		background-size: auto 1400px
		background-repeat: no-repeat
		background-position: center center
		background-image: url(/static/img/bg-intro.jpg)
		.linkSection
			position: fixed
			z-index: 5
			right: 0
			bottom: 0
			padding: 8px 10px 0
			background: rgba(0, 0, 0, 0.6)
			.logoSobo
				width: 84px
				height: 15px
			.logoWeddings
				width: 55px
				height: 15px
			a
				display: inline-block
				margin: 0 0 0 4px
				img
					width: 100%
		.KV
			position: absolute
			top: 50%
			left: 50%
			-webkit-transform: translate(-50%, -60%)
			-moz-transform: translate(-50%, -60%)
			-ms-transform: translate(-50%, -60%)
			-o-transform: translate(-50%, -60%)
			transform: translate(-50%, -60%)
		.couplets
			position: relative
			overflow: auto
			text-align: center
			width: 287px
			height: 291px
			background-repeat: no-repeat
			-webkit-background-size: 100% 100%
			-o-background-size: 100% 100%
			background-size: 100% 100%
			background-image: url(/static/img/mobile/bg-couplets.png)
			opacity: 0
			-webkit-transform: scale(0.2)
			-moz-transform: scale(0.2)
			-ms-transform: scale(0.2)
			-o-transform: scale(0.2)
			transform: scale(0.2)
			h1
				opacity: 0
				-webkit-transform: scale(0.2)
				-moz-transform: scale(0.2)
				-ms-transform: scale(0.2)
				-o-transform: scale(0.2)
				transform: scale(0.2)
				margin: 90px 0 0
				text-align: center
		.character
			background-repeat: no-repeat
			-webkit-background-size: 415px 410px
			-o-background-size: 415px 410px
			background-size: 415px 410px
			background-image: url(/static/img/mobile/character-intro.png)
		.lion
			position: absolute
			top: -6px
			right: -70px
			width: 170px
			height: 245px
			background-position: 0 0
			opacity: 0
			-webkit-transform: translateX(40px)
			-moz-transform: translateX(40px)
			-ms-transform: translateX(40px)
			-o-transform: translateX(40px)
			transform: translateX(40px)
		.bride
			position: absolute
			top: 138px
			left: -33px
			width: 130px
			height: 193px
			background-position: -285px 0
			opacity: 0
			-webkit-transform: translateY(20px)
			-moz-transform: translateY(20px)
			-ms-transform: translateY(20px)
			-o-transform: translateY(20px)
			transform: translateY(20px)
		.fatBoy
			position: absolute
			top: 170px
			right: -28px
			width: 120px
			height: 165px
			background-position: 0 -245px
			opacity: 0
			-webkit-transform: translateY(20px)
			-moz-transform: translateY(20px)
			-ms-transform: translateY(20px)
			-o-transform: translateY(20px)
			transform: translateY(20px)
		.oldWoman
			position: absolute
			top: 227px
			right: 16px
			width: 115px
			height: 135px
			background-position: -170px -96px
			opacity: 0
			-webkit-transform: translateY(20px)
			-moz-transform: translateY(20px)
			-ms-transform: translateY(20px)
			-o-transform: translateY(20px)
			transform: translateY(20px)
		.officeLady
			position: absolute
			top: 212px
			left: 22px
			width: 80px
			height: 155px
			background-position: -120px -245px
			opacity: 0
			-webkit-transform: translateY(20px)
			-moz-transform: translateY(20px)
			-ms-transform: translateY(20px)
			-o-transform: translateY(20px)
			transform: translateY(20px)
		.dog
			position: absolute
			top: 264px
			left: 100px
			width: 61px
			height: 105px
			background-position: -200px -245px
			opacity: 0
			-webkit-transform: translateY(20px)
			-moz-transform: translateY(20px)
			-ms-transform: translateY(20px)
			-o-transform: translateY(20px)
			transform: translateY(20px)
		.tsaiShen
			position: absolute
			top: 0
			left: 0
			bottom: 0
			right: 0
			margin: auto
			width: 96px
			height: 96px
			background-position: -170px 0
			&.right
				background-position: -261px -245px
		.btn
			position: absolute
			z-index: 5
			font-weight: bold
			color: #FFF
			-webkit-border-radius: 50px
			border-radius: 50px
			display: inline-block
			text-align: center
			padding: 2px
			text-decoration: none
			cursor: pointer
			-webkit-box-shadow: #108B86 0 5px 0
			box-shadow: #108B86 0 5px 0
			background: #21A8A3
			background: -moz-linear-gradient(top, #21A8A3 0%, #25B1AC 100%)
			background: -webkit-linear-gradient(top, #21A8A3 0%, #25B1AC 100%)
			background: linear-gradient(to bottom, #21A8A3 0%, #25B1AC 100%)
			opacity: 0
			-webkit-transform: scale(0.7)
			-moz-transform: scale(0.7)
			-ms-transform: scale(0.7)
			-o-transform: scale(0.7)
			transform: scale(0.7)
			border: 0
			top: 200px
			left: 50%
			margin-left: -50px
			&:active
				margin-top: 10px
				-webkit-box-shadow: none
				box-shadow: none
			.center
				position: relative
				padding: 4px 9px 5px
				-webkit-box-sizing: border-box
				-moz-box-sizing: border-box
				box-sizing: border-box
				font-weight: bold
				color: #FFF
				font-size: 15px
				text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 5px
				background-color: #21A8A3
				display: block
				width: 100%
				height: 100%
				-webkit-border-radius: 50px
				border-radius: 50px
			.arrow
				position: relative
				display: inline-block
				width: 14px
				height: 14px
				background-color: #FFF
				vertical-align: middle
				margin-top: -2px
				margin-left: 5px
				-webkit-border-radius: 50%
				border-radius: 50%
				-webkit-box-shadow: rgba(0, 0, 0, 0.5) 1px 1px 5px
				box-shadow: rgba(0, 0, 0, 0.5) 1px 1px 5px
				&::before
					position: absolute
					display: block
					content: ""
					width: 0
					height: 0
					top: 0
					left: 1px
					bottom: 0
					right: 0
					margin: auto
					border-style: solid
					border-color: transparent transparent transparent #21A8A3
					border-width: 4px 0 4px 5px

		.treasureGroup
			.treasure
				position: absolute
				&.coin
					opacity: 0
					width: 14px
					height: 14px
					background-size: 100% 100%
					background-image: url(/static/img/treasure_coinUnit.png)
				&.redPacket
					opacity: 0
					width: 27px
					height: 39px
					background-size: 100% 100%
					background-image: url(/static/img/treasure_redPacket.png)
				&.ingots
					opacity: 0
					width: 42px
					height: 27px
					background-size: 100% 100%
					background-image: url(/static/img/treasure_ingots.png)
	#moIntro
		&.active
			.lion
				-webkit-animation: lion 0.3s forwards
				-moz-animation: lion 0.3s forwards
				-o-animation: lion 0.3s forwards
				animation: lion 0.3s forwards
				-webkit-animation-delay: 1.1s
				-moz-animation-delay: 1.1s
				-o-animation-delay: 1.1s
				animation-delay: 1.1s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.bride
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 1.9s
				-moz-animation-delay: 1.9s
				-o-animation-delay: 1.9s
				animation-delay: 1.9s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.fatBoy
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2s
				-moz-animation-delay: 2s
				-o-animation-delay: 2s
				animation-delay: 2s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.oldWoman
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2.6s
				-moz-animation-delay: 2.6s
				-o-animation-delay: 2.6s
				animation-delay: 2.6s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.officeLady
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2.4s
				-moz-animation-delay: 2.4s
				-o-animation-delay: 2.4s
				animation-delay: 2.4s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.dog
				-webkit-animation: comeOut 0.4s forwards
				-moz-animation: comeOut 0.4s forwards
				-o-animation: comeOut 0.4s forwards
				animation: comeOut 0.4s forwards
				-webkit-animation-delay: 2.2s
				-moz-animation-delay: 2.2s
				-o-animation-delay: 2.2s
				animation-delay: 2.2s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.couplets
				-webkit-animation: couplets 0.5s forwards
				-moz-animation: couplets 0.5s forwards
				-o-animation: couplets 0.5s forwards
				animation: couplets 0.5s forwards
				-webkit-animation-delay: 0.7s
				-moz-animation-delay: 0.7s
				-o-animation-delay: 0.7s
				animation-delay: 0.7s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
				h1
					-webkit-animation: moSlogan 2.5s forwards
					-moz-animation: moSlogan 2.5s forwards
					-o-animation: moSlogan 2.5s forwards
					animation: moSlogan 2.5s forwards
					-webkit-animation-delay: 1.1s
					-moz-animation-delay: 1.1s
					-o-animation-delay: 1.1s
					animation-delay: 1.1s
					-webkit-animation-timing-function: linear
					-moz-animation-timing-function: linear
					-o-animation-timing-function: linear
					animation-timing-function: linear
			.tsaiShen
				-webkit-animation: moTsaiShen 0.5s forwards
				-moz-animation: moTsaiShen 0.5s forwards
				-o-animation: moTsaiShen 0.5s forwards
				animation: moTsaiShen 0.5s forwards
				-webkit-animation-delay: 0.3s
				-moz-animation-delay: 0.3s
				-o-animation-delay: 0.3s
				animation-delay: 0.3s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear
			.btn
				-webkit-animation: moBtn 0.5s forwards
				-moz-animation: moBtn 0.5s forwards
				-o-animation: moBtn 0.5s forwards
				animation: moBtn 0.5s forwards
				-webkit-animation-delay: 3.1s
				-moz-animation-delay: 3.1s
				-o-animation-delay: 3.1s
				animation-delay: 3.1s
				-webkit-animation-timing-function: linear
				-moz-animation-timing-function: linear
				-o-animation-timing-function: linear
				animation-timing-function: linear

		.treasureGroup
			&.active
				.treasure
					&.coin
						&_1
							top: 7px
							right: 5px
							-webkit-animation: mcoin1 1s forwards
							-moz-animation: mcoin1 1s forwards
							-o-animation: mcoin1 1s forwards
							animation: mcoin1 1s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
						&_2
							top: -20px
							right: -10px
							-webkit-animation: mcoin2 0.7s forwards
							-moz-animation: mcoin2 0.7s forwards
							-o-animation: mcoin2 0.7s forwards
							animation: mcoin2 0.7s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_3
							top: 5px
							right: 70px
							-webkit-animation: mcoin3 0.7s forwards
							-moz-animation: mcoin3 0.7s forwards
							-o-animation: mcoin3 0.7s forwards
							animation: mcoin3 0.7s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_4
							top: -40px
							right: -20px
							-webkit-animation: mcoin4 0.8s forwards
							-moz-animation: mcoin4 0.8s forwards
							-o-animation: mcoin4 0.8s forwards
							animation: mcoin4 0.8s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.15
							-moz-animation-delay: 0.15
							-o-animation-delay: 0.15
							animation-delay: 0.15
						&_5
							top: -40px
							right: -20px
							-webkit-animation: mcoin5 0.9s forwards
							-moz-animation: mcoin5 0.9s forwards
							-o-animation: mcoin5 0.9s forwards
							animation: mcoin5 0.9s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_6
							top: -40px
							right: -20px
							-webkit-animation: mcoin6 1s forwards
							-moz-animation: mcoin6 1s forwards
							-o-animation: mcoin6 1s forwards
							animation: mcoin6 1s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_7
							top: -40px
							right: -20px
							-webkit-animation: mcoin7 0.9s forwards
							-moz-animation: mcoin7 0.9s forwards
							-o-animation: mcoin7 0.9s forwards
							animation: mcoin7 0.9s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.15
							-moz-animation-delay: 0.15
							-o-animation-delay: 0.15
							animation-delay: 0.15
						&_8
							top: -40px
							right: -70px
							-webkit-animation: mcoin8 0.9s forwards
							-moz-animation: mcoin8 0.9s forwards
							-o-animation: mcoin8 0.9s forwards
							animation: mcoin8 0.9s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_9
							top: -33px
							right: -85px
							-webkit-animation: mcoin9 1s forwards
							-moz-animation: mcoin9 1s forwards
							-o-animation: mcoin9 1s forwards
							animation: mcoin9 1s forwards
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
					&.redPacket
						&_1
							top: -10px
							right: 40px
							-webkit-animation: mredPacket1 0.7s
							-moz-animation: mredPacket1 0.7s
							-o-animation: mredPacket1 0.7s
							animation: mredPacket1 0.7s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_2
							top: -80px
							right: -65px
							-webkit-animation: mredPacket2 0.7s
							-moz-animation: mredPacket2 0.7s
							-o-animation: mredPacket2 0.7s
							animation: mredPacket2 0.7s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_3
							top: -80px
							right: -15px
							-webkit-animation: mredPacket3 0.7s
							-moz-animation: mredPacket3 0.7s
							-o-animation: mredPacket3 0.7s
							animation: mredPacket3 0.7s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_4
							top: -80px
							right: -15px
							-webkit-animation: mredPacket3 0.9s
							-moz-animation: mredPacket3 0.9s
							-o-animation: mredPacket3 0.9s
							animation: mredPacket3 0.9s
							-webkit-animation-timing-function: linear
							-moz-animation-timing-function: linear
							-o-animation-timing-function: linear
							animation-timing-function: linear
					&.ingots
						@for $i from 1 through 4
							&_#{$i}
								top: -75px
								right: -40px
								-webkit-animation: mingots#{$i} 0.7s
								-moz-animation: mingots#{$i} 0.7s
								-o-animation: mingots#{$i} 0.7s
								animation: mingots#{$i} 0.7s
								-webkit-animation-timing-function: linear
								-moz-animation-timing-function: linear
								-o-animation-timing-function: linear
								animation-timing-function: linear
						&_1
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1
						&_2
							-webkit-animation-delay: 0.2
							-moz-animation-delay: 0.2
							-o-animation-delay: 0.2
							animation-delay: 0.2
						&_3
							-webkit-animation-delay: 0.1
							-moz-animation-delay: 0.1
							-o-animation-delay: 0.1
							animation-delay: 0.1

	@keyframes moTsaiShen
		100%
			-webkit-transform: translate(-95px, -113px)
			-moz-transform: translate(-95px, -113px)
			-ms-transform: translate(-95px, -113px)
			-o-transform: translate(-95px, -113px)
			transform: translate(-95px, -113px)
	@keyframes moSlogan
		8%
			opacity: 1
			-webkit-transform: scale(1.2)
			-moz-transform: scale(1.2)
			-ms-transform: scale(1.2)
			-o-transform: scale(1.2)
			transform: scale(1.2)
		12%
			opacity: 1
			-webkit-transform: scale(1.1)
			-moz-transform: scale(1.1)
			-ms-transform: scale(1.1)
			-o-transform: scale(1.1)
			transform: scale(1.1)
		84%
			opacity: 1
			-webkit-transform: scale(1.1)
			-moz-transform: scale(1.1)
			-ms-transform: scale(1.1)
			-o-transform: scale(1.1)
			transform: scale(1.1)
		92%
			opacity: 1
			-webkit-transform: scale(1) translateY(-22px)
			-moz-transform: scale(1) translateY(-22px)
			-ms-transform: scale(1) translateY(-22px)
			-o-transform: scale(1) translateY(-22px)
			transform: scale(1) translateY(-22px)
		100%
			opacity: 1
			-webkit-transform: scale(1) translateY(-15px)
			-moz-transform: scale(1) translateY(-15px)
			-ms-transform: scale(1) translateY(-15px)
			-o-transform: scale(1) translateY(-15px)
			transform: scale(1) translateY(-15px)
	@keyframes moBtn
		60%
			opacity: 1
			-webkit-transform: scale(1) translateY(-30px)
			-moz-transform: scale(1) translateY(-30px)
			-ms-transform: scale(1) translateY(-30px)
			-o-transform: scale(1) translateY(-30px)
			transform: scale(1) translateY(-30px)
		100%
			opacity: 1
			-webkit-transform: scale(1) translateY(-20px)
			-moz-transform: scale(1) translateY(-20px)
			-ms-transform: scale(1) translateY(-20px)
			-o-transform: scale(1) translateY(-20px)
			transform: scale(1) translateY(-20px)


	@keyframes mcoin1
		20%
			opacity: 1
			-webkit-transform: translate(60px, -20px)
			-moz-transform: translate(60px, -20px)
			-ms-transform: translate(60px, -20px)
			-o-transform: translate(60px, -20px)
			transform: translate(60px, -20px)
		50%
			opacity: 1
			-webkit-transform: translate(140px, 11px)
			-moz-transform: translate(140px, 11px)
			-ms-transform: translate(140px, 11px)
			-o-transform: translate(140px, 11px)
			transform: translate(140px, 11px)
		80%
			opacity: 1
			-webkit-transform: translate(267px, 149px)
			-moz-transform: translate(267px, 149px)
			-ms-transform: translate(267px, 149px)
			-o-transform: translate(267px, 149px)
			transform: translate(267px, 149px)
		100%
			opacity: 0
			-webkit-transform: translate(347px, 270px)
			-moz-transform: translate(347px, 270px)
			-ms-transform: translate(347px, 270px)
			-o-transform: translate(347px, 270px)
			transform: translate(347px, 270px)
	@keyframes mcoin2
		28%
			opacity: 1
			-webkit-transform: translate(155px, 81px)
			-moz-transform: translate(155px, 81px)
			-ms-transform: translate(155px, 81px)
			-o-transform: translate(155px, 81px)
			transform: translate(155px, 81px)
		72%
			opacity: 0.77
			-webkit-transform: translate(263px, 265px)
			-moz-transform: translate(263px, 265px)
			-ms-transform: translate(263px, 265px)
			-o-transform: translate(263px, 265px)
			transform: translate(263px, 265px)
		100%
			opacity: 0
			-webkit-transform: translate(318px, 358px)
			-moz-transform: translate(318px, 358px)
			-ms-transform: translate(318px, 358px)
			-o-transform: translate(318px, 358px)
			transform: translate(318px, 358px)
	@keyframes mcoin3
		28%
			opacity: 1
			-webkit-transform: translate(-62px, 87px)
			-moz-transform: translate(-62px, 87px)
			-ms-transform: translate(-62px, 87px)
			-o-transform: translate(-62px, 87px)
			transform: translate(-62px, 87px)
		86%
			opacity: 0.77
			-webkit-transform: translate(-127px, 242px)
			-moz-transform: translate(-127px, 242px)
			-ms-transform: translate(-127px, 242px)
			-o-transform: translate(-127px, 242px)
			transform: translate(-127px, 242px)
		100%
			opacity: 0
			-webkit-transform: translate(-181px, 326px)
			-moz-transform: translate(-181px, 326px)
			-ms-transform: translate(-181px, 326px)
			-o-transform: translate(-181px, 326px)
			transform: translate(-181px, 326px)
	@keyframes mcoin4
		28%
			opacity: 1
			-webkit-transform: translate(12px, 97px)
			-moz-transform: translate(12px, 97px)
			-ms-transform: translate(12px, 97px)
			-o-transform: translate(12px, 97px)
			transform: translate(12px, 97px)
		86%
			opacity: 0.77
			-webkit-transform: translate(30px, 243px)
			-moz-transform: translate(30px, 243px)
			-ms-transform: translate(30px, 243px)
			-o-transform: translate(30px, 243px)
			transform: translate(30px, 243px)
		100%
			opacity: 0
			-webkit-transform: translate(40px, 316px)
			-moz-transform: translate(40px, 316px)
			-ms-transform: translate(40px, 316px)
			-o-transform: translate(40px, 316px)
			transform: translate(40px, 316px)
	@keyframes mcoin5
		33%
			opacity: 1
			-webkit-transform: translate(-83px, 79px)
			-moz-transform: translate(-83px, 79px)
			-ms-transform: translate(-83px, 79px)
			-o-transform: translate(-83px, 79px)
			transform: translate(-83px, 79px)
		78%
			opacity: 0.77
			-webkit-transform: translate(-121px, 222px)
			-moz-transform: translate(-121px, 222px)
			-ms-transform: translate(-121px, 222px)
			-o-transform: translate(-121px, 222px)
			transform: translate(-121px, 222px)
		100%
			opacity: 0
			-webkit-transform: translate(-168px, 316px)
			-moz-transform: translate(-168px, 316px)
			-ms-transform: translate(-168px, 316px)
			-o-transform: translate(-168px, 316px)
			transform: translate(-168px, 316px)
	@keyframes mcoin6
		30%
			opacity: 1
			-webkit-transform: translate(118px, 5px)
			-moz-transform: translate(118px, 5px)
			-ms-transform: translate(118px, 5px)
			-o-transform: translate(118px, 5px)
			transform: translate(118px, 5px)
		80%
			opacity: 0.77
			-webkit-transform: translate(298px, 129px)
			-moz-transform: translate(298px, 129px)
			-ms-transform: translate(298px, 129px)
			-o-transform: translate(298px, 129px)
			transform: translate(298px, 129px)
		100%
			opacity: 0
			-webkit-transform: translate(381px, 343px)
			-moz-transform: translate(381px, 343px)
			-ms-transform: translate(381px, 343px)
			-o-transform: translate(381px, 343px)
			transform: translate(381px, 343px)
	@keyframes mcoin7
		30%
			opacity: 1
			-webkit-transform: translate(-14px, 106px)
			-moz-transform: translate(-14px, 106px)
			-ms-transform: translate(-14px, 106px)
			-o-transform: translate(-14px, 106px)
			transform: translate(-14px, 106px)
		90%
			opacity: 0.77
			-webkit-transform: translate(-36px, 264px)
			-moz-transform: translate(-36px, 264px)
			-ms-transform: translate(-36px, 264px)
			-o-transform: translate(-36px, 264px)
			transform: translate(-36px, 264px)
		100%
			opacity: 0
			-webkit-transform: translate(-47px, 344px)
			-moz-transform: translate(-47px, 344px)
			-ms-transform: translate(-47px, 344px)
			-o-transform: translate(-47px, 344px)
			transform: translate(-47px, 344px)
	@keyframes mcoin8
		33%
			opacity: 1
			-webkit-transform: translate(130px, 34px)
			-moz-transform: translate(130px, 34px)
			-ms-transform: translate(130px, 34px)
			-o-transform: translate(130px, 34px)
			transform: translate(130px, 34px)
		88%
			opacity: 0.77
			-webkit-transform: translate(296px, 189px)
			-moz-transform: translate(296px, 189px)
			-ms-transform: translate(296px, 189px)
			-o-transform: translate(296px, 189px)
			transform: translate(296px, 189px)
		100%
			opacity: 0
			-webkit-transform: translate(374px, 337px)
			-moz-transform: translate(374px, 337px)
			-ms-transform: translate(374px, 337px)
			-o-transform: translate(374px, 337px)
			transform: translate(374px, 337px)
	@keyframes mcoin9
		30%
			opacity: 1
			-webkit-transform: translate(144px, 51px)
			-moz-transform: translate(144px, 51px)
			-ms-transform: translate(144px, 51px)
			-o-transform: translate(144px, 51px)
			transform: translate(144px, 51px)
		80%
			opacity: 0.77
			-webkit-transform: translate(301px, 190px)
			-moz-transform: translate(301px, 190px)
			-ms-transform: translate(301px, 190px)
			-o-transform: translate(301px, 190px)
			transform: translate(301px, 190px)
		100%
			opacity: 0
			-webkit-transform: translate(359px, 291px)
			-moz-transform: translate(359px, 291px)
			-ms-transform: translate(359px, 291px)
			-o-transform: translate(359px, 291px)
			transform: translate(359px, 291px)

	@keyframes mredPacket1
		85%
			opacity: 1
			-webkit-transform: translate(-61px, 214px)
			-moz-transform: translate(-61px, 214px)
			-ms-transform: translate(-61px, 214px)
			-o-transform: translate(-61px, 214px)
			transform: translate(-61px, 214px)
		100%
			opacity: 0
			-webkit-transform: translate(-103px, 313px)
			-moz-transform: translate(-103px, 313px)
			-ms-transform: translate(-103px, 313px)
			-o-transform: translate(-103px, 313px)
			transform: translate(-103px, 313px)
	@keyframes mredPacket2
		72%
			opacity: 1
			-webkit-transform: translate(115px, 255px)
			-moz-transform: translate(115px, 255px)
			-ms-transform: translate(115px, 255px)
			-o-transform: translate(115px, 255px)
			transform: translate(115px, 255px)
		100%
			opacity: 0
			-webkit-transform: translate(175px, 348px)
			-moz-transform: translate(175px, 348px)
			-ms-transform: translate(175px, 348px)
			-o-transform: translate(175px, 348px)
			transform: translate(175px, 348px)
	@keyframes mredPacket3
		60%
			opacity: 1
			-webkit-transform: translate(19px, 273px)
			-moz-transform: translate(19px, 273px)
			-ms-transform: translate(19px, 273px)
			-o-transform: translate(19px, 273px)
			transform: translate(19px, 273px)
		100%
			opacity: 0
			-webkit-transform: translate(25px, 373px)
			-moz-transform: translate(25px, 373px)
			-ms-transform: translate(25px, 373px)
			-o-transform: translate(25px, 373px)
			transform: translate(25px, 373px)
	@keyframes mredPacket4
		33%
			opacity: 1
			-webkit-transform: translate(224px, 84px)
			-moz-transform: translate(224px, 84px)
			-ms-transform: translate(224px, 84px)
			-o-transform: translate(224px, 84px)
			transform: translate(224px, 84px)
		78%
			opacity: 1
			-webkit-transform: translate(301px, 212px)
			-moz-transform: translate(301px, 212px)
			-ms-transform: translate(301px, 212px)
			-o-transform: translate(301px, 212px)
			transform: translate(301px, 212px)
		100%
			opacity: 0
			-webkit-transform: translate(382px, 320px)
			-moz-transform: translate(382px, 320px)
			-ms-transform: translate(382px, 320px)
			-o-transform: translate(382px, 320px)
			transform: translate(382px, 320px)

	@keyframes mingots1
		85%
			opacity: 1
			-webkit-transform: translate(-137px, 228px)
			-moz-transform: translate(-137px, 228px)
			-ms-transform: translate(-137px, 228px)
			-o-transform: translate(-137px, 228px)
			transform: translate(-137px, 228px)
		100%
			opacity: 0
			-webkit-transform: translate(-192px, 319px)
			-moz-transform: translate(-192px, 319px)
			-ms-transform: translate(-192px, 319px)
			-o-transform: translate(-192px, 319px)
			transform: translate(-192px, 319px)
	@keyframes mingots2
		85%
			opacity: 1
			-webkit-transform: translate(59px, 218px)
			-moz-transform: translate(59px, 218px)
			-ms-transform: translate(59px, 218px)
			-o-transform: translate(59px, 218px)
			transform: translate(59px, 218px)
		100%
			opacity: 0
			-webkit-transform: translate(83px, 305px)
			-moz-transform: translate(83px, 305px)
			-ms-transform: translate(83px, 305px)
			-o-transform: translate(83px, 305px)
			transform: translate(83px, 305px)
	@keyframes mingots3
		85%
			opacity: 1
			-webkit-transform: translate(249px, 238px)
			-moz-transform: translate(249px, 238px)
			-ms-transform: translate(249px, 238px)
			-o-transform: translate(249px, 238px)
			transform: translate(249px, 238px)
		100%
			opacity: 0
			-webkit-transform: translate(349px, 333px)
			-moz-transform: translate(349px, 333px)
			-ms-transform: translate(349px, 333px)
			-o-transform: translate(349px, 333px)
			transform: translate(349px, 333px)
	@keyframes mingots4
		85%
			opacity: 1
			-webkit-transform: translate(133px, 280px)
			-moz-transform: translate(133px, 280px)
			-ms-transform: translate(133px, 280px)
			-o-transform: translate(133px, 280px)
			transform: translate(133px, 280px)
		100%
			opacity: 0
			-webkit-transform: translate(186px, 391px)
			-moz-transform: translate(186px, 391px)
			-ms-transform: translate(186px, 391px)
			-o-transform: translate(186px, 391px)
			transform: translate(186px, 391px)
</style>


// WEBPACK FOOTER //
// Intro.vue?52969d3c